import { Input } from "antd";
import { useAdvancedFormContext } from "../advanced-form";
import styled from "styled-components";

export const InputStyled = styled(Input)`
  &[readonly] {
    background: none;
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
  }
`

function FormItemString({readOnly, disabled, label, value, onChange}: any) {
  const advancedFormContext = useAdvancedFormContext()

  return (
    <InputStyled value={value} onChange={onChange} readOnly={readOnly || advancedFormContext?.readOnly} disabled={disabled} placeholder={label} />
  )
}

export default FormItemString;